// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[1].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[1].use[2]!./main-blessed3.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[1].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[1].use[2]!./main-blessed2.css");
var ___CSS_LOADER_AT_RULE_IMPORT_2___ = require("-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[1].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[1].use[2]!./main-blessed1.css");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./icons/Checkmark-grey.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./icons/Checkmark.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Homemade+Apple|Meddon|Shadows+Into+Light|Permanent+Marker|Schoolbell|Yellowtail);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Glyphicons Halflings";
  src: url("/fonts/glyphicons/glyphicons-webfont.woff2") format("woff2"),
    url("/fonts/glyphicons/glyphicons-webfont.woff") format("woff");
}

@font-face {
  font-family: "Glyphicons Halflings";
  src: url("/fonts/glyphicons/glyphicons-webfont.woff2") format("woff2"),
    url("/fonts/glyphicons/glyphicons-webfont.woff") format("woff");
}

.glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: "Glyphicons Halflings";
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.glyphicon-asterisk:before {
  content: "\\002a";
}

.glyphicon-plus:before {
  content: "\\002b";
}

.glyphicon-euro:before,
.glyphicon-eur:before {
  content: "\\20ac";
}

.glyphicon-minus:before {
  content: "\\2212";
}

.glyphicon-cloud:before {
  content: "\\2601";
}

.glyphicon-envelope:before {
  content: "\\2709";
}

.glyphicon-pencil:before {
  content: "\\270f";
}

.glyphicon-glass:before {
  content: "\\e001";
}

.glyphicon-music:before {
  content: "\\e002";
}

.glyphicon-search:before {
  content: "\\e003";
}

.glyphicon-heart:before {
  content: "\\e005";
}

.glyphicon-star:before {
  content: "\\e006";
}

.glyphicon-star-empty:before {
  content: "\\e007";
}

.glyphicon-user:before {
  content: "\\e008";
}

.glyphicon-film:before {
  content: "\\e009";
}

.glyphicon-th-large:before {
  content: "\\e010";
}

.glyphicon-th:before {
  content: "\\e011";
}

.glyphicon-th-list:before {
  content: "\\e012";
}

.glyphicon-ok:before {
  content: "\\e013";
}

.glyphicon-remove:before {
  content: "\\e014";
}

.glyphicon-zoom-in:before {
  content: "\\e015";
}

.glyphicon-zoom-out:before {
  content: "\\e016";
}

.glyphicon-off:before {
  content: "\\e017";
}

.glyphicon-signal:before {
  content: "\\e018";
}

.glyphicon-cog:before {
  content: "\\e019";
}

.glyphicon-trash:before {
  content: "\\e020";
}

.glyphicon-home:before {
  content: "\\e021";
}

.glyphicon-file:before {
  content: "\\e022";
}

.glyphicon-time:before {
  content: "\\e023";
}

.glyphicon-road:before {
  content: "\\e024";
}

.glyphicon-download-alt:before {
  content: "\\e025";
}

.glyphicon-download:before {
  content: "\\e026";
}

.glyphicon-upload:before {
  content: "\\e027";
}

.glyphicon-inbox:before {
  content: "\\e028";
}

.glyphicon-play-circle:before {
  content: "\\e029";
}

.glyphicon-repeat:before {
  content: "\\e030";
}

.glyphicon-refresh:before {
  content: "\\e031";
}

.glyphicon-list-alt:before {
  content: "\\e032";
}

.glyphicon-lock:before {
  content: "\\e033";
}

.glyphicon-flag:before {
  content: "\\e034";
}

.glyphicon-headphones:before {
  content: "\\e035";
}

.glyphicon-volume-off:before {
  content: "\\e036";
}

.glyphicon-volume-down:before {
  content: "\\e037";
}

.glyphicon-volume-up:before {
  content: "\\e038";
}

.glyphicon-qrcode:before {
  content: "\\e039";
}

.glyphicon-barcode:before {
  content: "\\e040";
}

.glyphicon-tag:before {
  content: "\\e041";
}

.glyphicon-tags:before {
  content: "\\e042";
}

.glyphicon-book:before {
  content: "\\e043";
}

.glyphicon-bookmark:before {
  content: "\\e044";
}

.glyphicon-print:before {
  content: "\\e045";
}

.glyphicon-camera:before {
  content: "\\e046";
}

.glyphicon-font:before {
  content: "\\e047";
}

.glyphicon-bold:before {
  content: "\\e048";
}

.glyphicon-italic:before {
  content: "\\e049";
}

.glyphicon-text-height:before {
  content: "\\e050";
}

.glyphicon-text-width:before {
  content: "\\e051";
}

.glyphicon-align-left:before {
  content: "\\e052";
}

.glyphicon-align-center:before {
  content: "\\e053";
}

.glyphicon-align-right:before {
  content: "\\e054";
}

.glyphicon-align-justify:before {
  content: "\\e055";
}

.glyphicon-list:before {
  content: "\\e056";
}

.glyphicon-indent-left:before {
  content: "\\e057";
}

.glyphicon-indent-right:before {
  content: "\\e058";
}

.glyphicon-facetime-video:before {
  content: "\\e059";
}

.glyphicon-picture:before {
  content: "\\e060";
}

.glyphicon-map-marker:before {
  content: "\\e062";
}

.glyphicon-adjust:before {
  content: "\\e063";
}

.glyphicon-tint:before {
  content: "\\e064";
}

.glyphicon-edit:before {
  content: "\\e065";
}

.glyphicon-share:before {
  content: "\\e066";
}

.glyphicon-check:before {
  content: "\\e067";
}

.glyphicon-move:before {
  content: "\\e068";
}

.glyphicon-step-backward:before {
  content: "\\e069";
}

.glyphicon-fast-backward:before {
  content: "\\e070";
}

.glyphicon-backward:before {
  content: "\\e071";
}

.glyphicon-play:before {
  content: "\\e072";
}

.glyphicon-pause:before {
  content: "\\e073";
}

.glyphicon-stop:before {
  content: "\\e074";
}

.glyphicon-forward:before {
  content: "\\e075";
}

.glyphicon-fast-forward:before {
  content: "\\e076";
}

.glyphicon-step-forward:before {
  content: "\\e077";
}

.glyphicon-eject:before {
  content: "\\e078";
}

.glyphicon-chevron-left:before {
  content: "\\e079";
}

.glyphicon-chevron-right:before {
  content: "\\e080";
}

.glyphicon-plus-sign:before {
  content: "\\e081";
}

.glyphicon-minus-sign:before {
  content: "\\e082";
}

.glyphicon-remove-sign:before {
  content: "\\e083";
}

.glyphicon-ok-sign:before {
  content: "\\e084";
}

.glyphicon-question-sign:before {
  content: "\\e085";
}

.glyphicon-info-sign:before {
  content: "\\e086";
}

.glyphicon-screenshot:before {
  content: "\\e087";
}

.glyphicon-remove-circle:before {
  content: "\\e088";
}

.glyphicon-ok-circle:before {
  content: "\\e089";
}

.glyphicon-ban-circle:before {
  content: "\\e090";
}

.glyphicon-arrow-left:before {
  content: "\\e091";
}

.glyphicon-arrow-right:before {
  content: "\\e092";
}

.glyphicon-arrow-up:before {
  content: "\\e093";
}

.glyphicon-arrow-down:before {
  content: "\\e094";
}

.glyphicon-share-alt:before {
  content: "\\e095";
}

.glyphicon-resize-full:before {
  content: "\\e096";
}

.glyphicon-resize-small:before {
  content: "\\e097";
}

.glyphicon-exclamation-sign:before {
  content: "\\e101";
}

.glyphicon-gift:before {
  content: "\\e102";
}

.glyphicon-leaf:before {
  content: "\\e103";
}

.glyphicon-fire:before {
  content: "\\e104";
}

.glyphicon-eye-open:before {
  content: "\\e105";
}

.glyphicon-eye-close:before {
  content: "\\e106";
}

.glyphicon-warning-sign:before {
  content: "\\e107";
}

.glyphicon-plane:before {
  content: "\\e108";
}

.glyphicon-calendar:before {
  content: "\\e109";
}

.glyphicon-random:before {
  content: "\\e110";
}

.glyphicon-comment:before {
  content: "\\e111";
}

.glyphicon-magnet:before {
  content: "\\e112";
}

.glyphicon-chevron-up:before {
  content: "\\e113";
}

.glyphicon-chevron-down:before {
  content: "\\e114";
}

.glyphicon-retweet:before {
  content: "\\e115";
}

.glyphicon-shopping-cart:before {
  content: "\\e116";
}

.glyphicon-folder-close:before {
  content: "\\e117";
}

.glyphicon-folder-open:before {
  content: "\\e118";
}

.glyphicon-resize-vertical:before {
  content: "\\e119";
}

.glyphicon-resize-horizontal:before {
  content: "\\e120";
}

.glyphicon-hdd:before {
  content: "\\e121";
}

.glyphicon-bullhorn:before {
  content: "\\e122";
}

.glyphicon-bell:before {
  content: "\\e123";
}

.glyphicon-certificate:before {
  content: "\\e124";
}

.glyphicon-thumbs-up:before {
  content: "\\e125";
}

.glyphicon-thumbs-down:before {
  content: "\\e126";
}

.glyphicon-hand-right:before {
  content: "\\e127";
}

.glyphicon-hand-left:before {
  content: "\\e128";
}

.glyphicon-hand-up:before {
  content: "\\e129";
}

.glyphicon-hand-down:before {
  content: "\\e130";
}

.glyphicon-circle-arrow-right:before {
  content: "\\e131";
}

.glyphicon-circle-arrow-left:before {
  content: "\\e132";
}

.glyphicon-circle-arrow-up:before {
  content: "\\e133";
}

.glyphicon-circle-arrow-down:before {
  content: "\\e134";
}

.glyphicon-globe:before {
  content: "\\e135";
}

.glyphicon-wrench:before {
  content: "\\e136";
}

.glyphicon-tasks:before {
  content: "\\e137";
}

.glyphicon-filter:before {
  content: "\\e138";
}

.glyphicon-briefcase:before {
  content: "\\e139";
}

.glyphicon-fullscreen:before {
  content: "\\e140";
}

.glyphicon-dashboard:before {
  content: "\\e141";
}

.glyphicon-paperclip:before {
  content: "\\e142";
}

.glyphicon-heart-empty:before {
  content: "\\e143";
}

.glyphicon-link:before {
  content: "\\e144";
}

.glyphicon-phone:before {
  content: "\\e145";
}

.glyphicon-pushpin:before {
  content: "\\e146";
}

.glyphicon-usd:before {
  content: "\\e148";
}

.glyphicon-gbp:before {
  content: "\\e149";
}

.glyphicon-sort:before {
  content: "\\e150";
}

.glyphicon-sort-by-alphabet:before {
  content: "\\e151";
}

.glyphicon-sort-by-alphabet-alt:before {
  content: "\\e152";
}

.glyphicon-sort-by-order:before {
  content: "\\e153";
}

.glyphicon-sort-by-order-alt:before {
  content: "\\e154";
}

.glyphicon-sort-by-attributes:before {
  content: "\\e155";
}

.glyphicon-sort-by-attributes-alt:before {
  content: "\\e156";
}

.glyphicon-unchecked:before {
  content: "\\e157";
}

.glyphicon-expand:before {
  content: "\\e158";
}

.glyphicon-collapse-down:before {
  content: "\\e159";
}

.glyphicon-collapse-up:before {
  content: "\\e160";
}

.glyphicon-log-in:before {
  content: "\\e161";
}

.glyphicon-flash:before {
  content: "\\e162";
}

.glyphicon-log-out:before {
  content: "\\e163";
}

.glyphicon-new-window:before {
  content: "\\e164";
}

.glyphicon-record:before {
  content: "\\e165";
}

.glyphicon-save:before {
  content: "\\e166";
}

.glyphicon-open:before {
  content: "\\e167";
}

.glyphicon-saved:before {
  content: "\\e168";
}

.glyphicon-import:before {
  content: "\\e169";
}

.glyphicon-export:before {
  content: "\\e170";
}

.glyphicon-send:before {
  content: "\\e171";
}

.glyphicon-floppy-disk:before {
  content: "\\e172";
}

.glyphicon-floppy-saved:before {
  content: "\\e173";
}

.glyphicon-floppy-remove:before {
  content: "\\e174";
}

.glyphicon-floppy-save:before {
  content: "\\e175";
}

.glyphicon-floppy-open:before {
  content: "\\e176";
}

.glyphicon-credit-card:before {
  content: "\\e177";
}

.glyphicon-transfer:before {
  content: "\\e178";
}

.glyphicon-cutlery:before {
  content: "\\e179";
}

.glyphicon-header:before {
  content: "\\e180";
}

.glyphicon-compressed:before {
  content: "\\e181";
}

.glyphicon-earphone:before {
  content: "\\e182";
}

.glyphicon-phone-alt:before {
  content: "\\e183";
}

.glyphicon-tower:before {
  content: "\\e184";
}

.glyphicon-stats:before {
  content: "\\e185";
}

.glyphicon-sd-video:before {
  content: "\\e186";
}

.glyphicon-hd-video:before {
  content: "\\e187";
}

.glyphicon-subtitles:before {
  content: "\\e188";
}

.glyphicon-sound-stereo:before {
  content: "\\e189";
}

.glyphicon-sound-dolby:before {
  content: "\\e190";
}

.glyphicon-sound-5-1:before {
  content: "\\e191";
}

.glyphicon-sound-6-1:before {
  content: "\\e192";
}

.glyphicon-sound-7-1:before {
  content: "\\e193";
}

.glyphicon-copyright-mark:before {
  content: "\\e194";
}

.glyphicon-registration-mark:before {
  content: "\\e195";
}

.glyphicon-cloud-download:before {
  content: "\\e197";
}

.glyphicon-cloud-upload:before {
  content: "\\e198";
}

.glyphicon-tree-conifer:before {
  content: "\\e199";
}

.glyphicon-tree-deciduous:before {
  content: "\\e200";
}

.glyphicon-cd:before {
  content: "\\e201";
}

.glyphicon-save-file:before {
  content: "\\e202";
}

.glyphicon-open-file:before {
  content: "\\e203";
}

.glyphicon-level-up:before {
  content: "\\e204";
}

.glyphicon-copy:before {
  content: "\\e205";
}

.glyphicon-paste:before {
  content: "\\e206";
}

/**
 * .glyphicon-door                   { &:before { content: "\\1f6aa"; } }
 * .glyphicon-key                    { &:before { content: "\\1f511"; } }
 */
.glyphicon-alert:before {
  content: "\\e209";
}

.glyphicon-equalizer:before {
  content: "\\e210";
}

.glyphicon-king:before {
  content: "\\e211";
}

.glyphicon-queen:before {
  content: "\\e212";
}

.glyphicon-pawn:before {
  content: "\\e213";
}

.glyphicon-bishop:before {
  content: "\\e214";
}

.glyphicon-knight:before {
  content: "\\e215";
}

.glyphicon-baby-formula:before {
  content: "\\e216";
}

.glyphicon-tent:before {
  content: "\\26fa";
}

.glyphicon-blackboard:before {
  content: "\\e218";
}

.glyphicon-bed:before {
  content: "\\e219";
}

.glyphicon-apple:before {
  content: "\\f8ff";
}

.glyphicon-erase:before {
  content: "\\e221";
}

.glyphicon-hourglass:before {
  content: "\\231b";
}

.glyphicon-lamp:before {
  content: "\\e223";
}

.glyphicon-duplicate:before {
  content: "\\e224";
}

.glyphicon-piggy-bank:before {
  content: "\\e225";
}

.glyphicon-scissors:before {
  content: "\\e226";
}

.glyphicon-bitcoin:before {
  content: "\\e227";
}

.glyphicon-btc:before {
  content: "\\e227";
}

.glyphicon-xbt:before {
  content: "\\e227";
}

.glyphicon-yen:before {
  content: "\\00a5";
}

.glyphicon-jpy:before {
  content: "\\00a5";
}

.glyphicon-ruble:before {
  content: "\\20bd";
}

.glyphicon-rub:before {
  content: "\\20bd";
}

.glyphicon-scale:before {
  content: "\\e230";
}

.glyphicon-ice-lolly:before {
  content: "\\e231";
}

.glyphicon-ice-lolly-tasted:before {
  content: "\\e232";
}

.glyphicon-education:before {
  content: "\\e233";
}

.glyphicon-option-horizontal:before {
  content: "\\e234";
}

.glyphicon-option-vertical:before {
  content: "\\e235";
}

.glyphicon-menu-hamburger:before {
  content: "\\e236";
}

.glyphicon-modal-window:before {
  content: "\\e237";
}

.glyphicon-oil:before {
  content: "\\e238";
}

.glyphicon-grain:before {
  content: "\\e239";
}

.glyphicon-sunglasses:before {
  content: "\\e240";
}

.glyphicon-text-size:before {
  content: "\\e241";
}

.glyphicon-text-color:before {
  content: "\\e242";
}

.glyphicon-text-background:before {
  content: "\\e243";
}

.glyphicon-object-align-top:before {
  content: "\\e244";
}

.glyphicon-object-align-bottom:before {
  content: "\\e245";
}

.glyphicon-object-align-horizontal:before {
  content: "\\e246";
}

.glyphicon-object-align-left:before {
  content: "\\e247";
}

.glyphicon-object-align-vertical:before {
  content: "\\e248";
}

.glyphicon-object-align-right:before {
  content: "\\e249";
}

.glyphicon-triangle-right:before {
  content: "\\e250";
}

.glyphicon-triangle-left:before {
  content: "\\e251";
}

.glyphicon-triangle-bottom:before {
  content: "\\e252";
}

.glyphicon-triangle-top:before {
  content: "\\e253";
}

.glyphicon-console:before {
  content: "\\e254";
}

.glyphicon-superscript:before {
  content: "\\e255";
}

.glyphicon-subscript:before {
  content: "\\e256";
}

.glyphicon-menu-left:before {
  content: "\\e257";
}

.glyphicon-menu-right:before {
  content: "\\e258";
}

.glyphicon-menu-down:before {
  content: "\\e259";
}

.glyphicon-menu-up:before {
  content: "\\e260";
}
/* Component styles */

.testHover {
  background: #fff;
}
.testHover:hover {
  background: #e8f4f8;
  border-radius: 20px;
}

#sidebar .rubix-timeline-view .rubix-timeline-title {
  background: none;
  padding: 4px 0px;
}

#sidebar .rubix-timeline-view .rubix-timeline-body li:before {
  -webkit-box-shadow: 0px 0px 0px 6px #000e89;
          box-shadow: 0px 0px 0px 6px #000e89;
}

/* Page styles */
.todo-item {
  border-bottom: 1px solid #eee;
}

.todo-item button {
  display: none;
  margin-top: 8px;
}

.todo-item:hover {
  background: #fefef4;
}

.todo-item:hover button {
  display: inline-block;
}

/* CHECK */
@media (max-width: 989px) {
  .todo-item .text-right {
    display: none;
  }

  .todo-item:hover .text-right {
    display: block;
    text-align: center;
    margin-bottom: 12.5px;
  }
}

html.authentication {
  background: #43525a !important;
}

html.authentication body {
  background: #43525a !important;
}

#auth-container {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  overflow: auto;
  position: fixed;
  background: #ffffff;
}

#auth-container.bgImage {
  background-image: url("/imgs/app/bg.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  overflow: hidden;
}

#auth-row {
  margin: auto;
  display: block;
  margin-top: 50px;
}

#auth-row-0 {
  margin: auto;
  display: block;
  margin-top: 0px;
}

.text-bottom {
  z-index: 1;
  bottom: 15px;
  margin-left: -10px;
  position: fixed;
}

.text-bottom-splash {
  bottom: 0;
  width: 100%;
  position: absolute;
}

.splash-body {
  height: 1500px;
  max-height: 89.79%;
  position: absolute;
  background-color: #ffffff;
}

.splash-container {
  margin: 10px 0px 30px 90px;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  background: rgb(247, 247, 247);
  padding: 30px;
  height: 85%;
  overflow: auto;
}

.text-bottom-color {
  padding-left: 10px;
}

.app-logo {
  padding: 20px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-50 {
  margin-top: 50px;
}

.bg-custom-colot-blue {
  background: rgb(247, 247, 247);
}

.loginFrom {
  border-radius: 10px;
  margin: 20px;
  margin-left: 40px;
  margin-right: 40px;
  max-height: 75%;
  position: absolute;
  overflow: hidden;
}

.scale {
  width: 96%;
}

#auth-cell {
  margin: auto;
}

/* CHECK */
@media (max-width: 1025px) {
  .scale {
    width: 92%;
  }
}

@media (max-width: 768px) {
  #auth-cell > div {
    width: 100% !important;
  }

  .back-btn, .review-btn, .next-btn {
    width: unset !important;
  }
}

#auth-container.login #facebook-btn {
  position: relative;
  border-radius: 4px;
  background: #2960b1;
  text-transform: none;
  border-color: #2960b1;
}

#auth-container.login #facebook-btn:hover,
#auth-container.login #facebook-btn:focus {
  background: #1f4a88;
  border-color: #1f4a88;
}

#auth-container.login #facebook-btn > .rubix-icon {
  top: 10px;
  left: 20px;
  font-size: 28px;
  position: absolute;
  vertical-align: top;
}

#auth-container.login #facebook-btn > .rubix-icon + span {
  font-size: 18px;
  padding-left: 20px;
  position: relative;
}

#auth-container.login a {
  color: #4a90e2;
  border-color: #4a90e2;
}

#auth-container.login a:hover,
#auth-container.login a:focus {
  color: #4a90e2;
  border-color: #4a90e2;
}

#auth-container.signup #facebook-btn,
#auth-container.signup #twitter-btn {
  position: relative;
  border-radius: 4px;
  text-transform: none;
}

#auth-container.signup #facebook-btn > .rubix-icon,
#auth-container.signup #twitter-btn > .rubix-icon {
  top: 10px;
  left: 20px;
  font-size: 28px;
  position: absolute;
  vertical-align: top;
}

#auth-container.signup #facebook-btn > .rubix-icon + span,
#auth-container.signup #twitter-btn > .rubix-icon + span {
  font-size: 18px;
  padding-left: 20px;
  position: relative;
}

#auth-container.signup #twitter-btn {
  background: #00acdf;
  border-color: #00acdf;
}

#auth-container.signup #twitter-btn:hover,
#auth-container.signup #twitter-btn:focus {
  background: #0085ac;
  border-color: #0085ac;
}

#auth-container.signup #facebook-btn {
  background: #2960b1;
  border-color: #2960b1;
}

#auth-container.signup #facebook-btn:hover,
#auth-container.signup #facebook-btn:focus {
  background: #1f4a88;
  border-color: #1f4a88;
}

#auth-container.signup .facebook-container {
  margin-bottom: 12.5px;
}

/* CHECK */
@media (min-width: 990px) {
  #auth-container.signup .facebook-container {
    margin-bottom: 0px;
    padding-right: 12.5px;
  }

  #auth-container.signup .twitter-container {
    padding-left: 12.5px;
  }
}

#auth-container.signup a {
  color: #4a90e2;
  border-color: #4a90e2;
}

#auth-container.signup a:hover,
#auth-container.signup a:focus {
  color: #4a90e2;
  border-color: #4a90e2;
}

#auth-container.lockpage #auth-cell > div {
  width: 700px;
}

#auth-container.lockpage label {
  color: black;
  width: 200px;
  font-weight: 400;
  background: white;
  position: relative;
  text-align: center;
  margin-right: -5px;
  display: inline-block;
  padding: 12.5px 25px;
}

#auth-container.lockpage img {
  border-radius: 100px;
  display: inline-block;
  border: 7px solid white;
}

#auth-container.lockpage input[type="password"] {
  width: 200px;
  height: auto;
  border: none;
  margin-left: -5px;
  text-align: center;
  position: relative;
  display: inline-block;
  padding: 12px 25px;
}

@media (max-width: 568px) {
  #auth-container.lockpage h1 {
    font-size: 72px !important;
  }

  #auth-container.lockpage input[type="password"],
  #auth-container.lockpage label {
    margin: auto;
    display: block;
  }

  #auth-container.lockpage input[type="password"] {
    margin-top: 10px;
  }

  #auth-container.lockpage img {
    display: none;
  }

  .backiconspan {
    display: none;
  }

  .nexticonspan {
    display: none;
  }
}

.blog-sidebar-heading {
  padding-bottom: 5px;
  border-bottom: 1px dashed #ccc;
  margin-bottom: 12.5px;
}

.blog-post-header {
  height: 350px;
  background-size: cover;
  background-position: center;
  background-image: url(/imgs/app/gallery/tumblr_na0kb0BLqR1st5lhmo1_1280.jpg);
}

.blog-post-header:after {
  content: " ";
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7);
}

.blog-post-btn-holder > button {
  border-color: transparent !important;
}

.inbox-toolbar {
  top: 5px;
  position: relative;
  display: inline-block;
}

/* CHECK */
@media (min-width: 1152px) {
  .inbox-toolbar {
    top: 10px;
  }
}
/* CHECK */
@media (min-width: 900px) {
  .col-md-6 {
    width: 50%;
    float: left;
  }
}
.inbox-avatar {
  padding-top: 12.5px;
  padding-bottom: 12.5px;
}

.inbox-avatar-name {
  text-align: left;
  padding-left: 12.5px;
  display: inline-block;
  vertical-align: middle;
}

.inbox-avatar-name > div:first-child {
  top: 5px;
  position: relative;
}

.inbox-avatar-name > div:last-child > small {
  top: -5px;
  position: relative;
}

.inbox-nav {
  border-right: 1px solid #eee;
}

.inbox-nav .badge {
  width: 10px;
  height: 14px;
  margin-top: -3px;
  margin-right: 10px;
  border-radius: 100px;
  vertical-align: middle;
}

.inbox-nav .list-group-item {
  color: #555;
  border: none;
  padding: 10px 25px;
  margin: -25px;
  margin-top: 0;
  margin-bottom: 5px;
  border-radius: 0 !important;
}

.inbox-nav .list-group-item:hover,
.inbox-nav .list-group-item:focus {
  border: none !important;
}

.inbox-nav .list-group-item .badge {
  top: 0;
  float: none;
}

.inbox-nav hr {
  margin-top: -5px;
}

.inbox-nav .list-group-item .inbox-item-icon {
  float: left;
  font-size: 18px;
  position: relative;
  vertical-align: baseline;
  margin-right: 12.5px;
}

.inbox-nav .list-group-item .inbox-item-icon[class*="icon-simple-line-"],
.inbox-nav .list-group-item .inbox-item-icon[class*="icon-dripicons-"],
.inbox-nav .list-group-item .inbox-item-icon[class*="icon-fontello-"] {
  top: 2px;
}

.inbox-nav .list-group-item .inbox-item-icon ~ span {
  position: relative;
  display: block;
  line-height: 36px;
  height: 36px;
}

.inbox-item {
  color: inherit;
  display: block;
  padding-bottom: 0 !important;
  margin-left: -25px;
  margin-right: -25px;
  padding-left: 25px;
  padding-right: 25px;
  border-bottom: 1px solid #eee !important;
  background: #f9f9f9;
}

.inbox-item:last-child {
  border-bottom: none !important;
}

.inbox-item.unread {
  background: white;
}

.inbox-item:hover,
.inbox-item:focus {
  color: inherit;
  background: rgba(255, 255, 102, 0.2);
}

.inbox-item img {
  padding: 2px;
  border-radius: 100px;
  border: 2px solid #eee;
}

.inbox-item .inbox-avatar-name > div:first-child {
  top: 2px;
}

.inbox-date {
  float: right;
}

.inbox-attachments > .rubix-icon {
  float: left;
  line-height: 1;
}

.inbox-attachments > .rubix-icon ~ span {
  top: -2px;
  left: 10px;
  position: relative;
}

.inbox-attachment-download {
  float: right;
}

#wizard-2 .form-border {
  border-right: 1px solid #ddd;
}

#body.social {
  background: #fff !important;
}

#body.social .rubix-panel-container {
  border: 2px solid #eaedf1;
}

#body.social .rubix-panel-controls {
  border: 2px solid #eaedf1;
  border-bottom: none;
}

#body.social .rubix-panel-controls > button {
  top: -5px;
}

#body.social .rubix-panel-footer {
  border-radius: 0;
}

html.social body .sidebar-nav > li.active:after {
  display: none !important;
}

.Select-value-label,
.Select-option {
  white-space: pre-wrap;
}

.social-desc {
  top: 0;
  left: 0;
  bottom: 0;
  right: 300px;
  position: absolute;
}

.social-desc > div {
  margin-left: 10%;
  margin-top: 100px;
}

/* CHECK */
@media (max-width: 650px) {
  .social-desc {
    display: none;
  }
}

.social-avatar {
  top: 0;
  right: 0;
  bottom: 0;
  width: 300px;
  position: absolute;
  background: -webkit-gradient(
    linear,
    left top, left bottom,
    from(rgba(0, 0, 0, 0.3)),
    to(rgba(0, 0, 0, 0.5))
  );
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
}
/* CHECK */
@media (max-width: 650px) {
  .social-avatar {
    left: 0;
    width: auto;
  }
}

.social-like-count {
  cursor: pointer;
  display: inline-block;
}

.social-like-count > span {
  margin-left: 25px;
}

#ex1Slider .slider-selection {
  background: #55c9a6;
}

#RGB {
  max-width: 220px;
  height: 100px;
  background: #80c880;
}

#RC .slider-selection {
  background: #ff8282;
}

#RC .slider-handle {
  background: red;
}

#GC .slider-selection {
  background: #428041;
}

#GC .slider-handle {
  background: green;
}

#BC .slider-selection {
  background: #8283ff;
}

#BC .slider-handle {
  border-bottom-color: blue;
}

#R,
#G,
#B {
  width: 300px;
}

.gallery-view {
  padding-right: 25px;
}

.gallery-item .black-wrapper {
  top: 0;
  bottom: 0;
  opacity: 0;
  background: #000;
  left: 0;
  right: 0;
  position: absolute;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.gallery-item .black-wrapper td {
  vertical-align: middle;
}

.gallery-item .black-wrapper .rubix-icon {
  color: white;
  display: block;
}

.gallery-item-link {
  display: block;
  overflow: hidden;
  position: relative;
  padding: 0 !important;
  border: none !important;
}

.gallery-item-link:hover .black-wrapper,
.gallery-item-link:focus .black-wrapper {
  opacity: 1;
  background: rgba(0, 0, 0, 0.5);
}

.fav-btn > .rubix-icon {
  font-size: 20px !important;
  line-height: 20px !important;
}

.fav-btn > .counts {
  top: -6px;
  line-height: 0;
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  display: inline-block;
  vertical-align: middle !important;
}

html.boxed #homepage-container {
  height: 100%;
  overflow: auto;
  position: relative;
}

#demo-btn {
  right: 0;
  z-index: 3;
  height: auto;
  opacity: 0.6;
  position: fixed;
  border-radius: 0;
  border-top: none;
  border-right: none;
  padding-top: 7px !important;
  padding-left: 25px !important;
  padding-bottom: 8px !important;
  border-bottom-left-radius: 15px;
}

#demo-btn:hover,
#demo-btn:focus {
  opacity: 1;
}

.homepage-hero {
  font-weight: 300;
  padding-top: 50px;
  padding-bottom: 50px;
}

.homepage-hero:nth-child(odd) {
  background: white;
}

.homepage-hero:nth-child(even) {
  background: #eaedf1;
}

.homepage-hero-header,
.homepage-hero-header2 {
  text-align: center;
  letter-spacing: 1.2px;
}

.homepage-hero-header {
  color: #333333;
  font-size: 32px;
  line-height: 39px;
}

.homepage-hero-header2 {
  color: #89949b;
  font-size: 36px;
  line-height: 44px;
}

.homepage-hero p {
  color: #89949b;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.8px;
}

.homepage-hero .label {
  padding-top: 8px;
  padding-left: 12px;
  padding-bottom: 6px;
}

.homepage-hero hr {
  height: 1px;
  margin: 50px 0;
  background: -webkit-gradient(linear, right top, left top, from(transparent), color-stop(gainsboro), to(transparent));
  background: linear-gradient(to left, transparent, gainsboro, transparent);
  border: 0;
}

.homepage-hero hr:after {
  display: block;
  content: "";
  height: 5px;
  background-image: radial-gradient(
    farthest-side at center top,
    #e2e2e2 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

.homepage-hero .nav {
  z-index: 2;
  width: 100%;
  display: table;
  position: relative;
}

.homepage-hero .nav > li {
  width: 14.1%;
  opacity: 0.7;
  display: table-row;
}

.homepage-hero .nav > li > a {
  outline: none;
  padding: 12.5px;
  border: 1px solid transparent;
  border-bottom: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.homepage-hero .nav > li:hover .homepage-hero .nav > li:focus > a {
  background: rgba(242, 242, 242, 0.15);
}

.homepage-hero .nav > li.active {
  opacity: 1;
}

.homepage-hero .nav > li.active > a {
  border: 1px solid #eee;
  border-bottom: none;
  background: #fbfbfb;
}

.homepage-hero .nav > li.active > a:after {
  left: 0;
  right: 0;
  content: " ";
  bottom: -1px;
  position: absolute;
  border: 1px solid #fcfcfc;
}

.homepage-hero .tab-content {
  z-index: 0;
  position: relative;
  border: 1px solid #eee;
}

.homepage-hero .tab-content > .active {
  color: #555;
  padding: 25px;
  font-size: 16px;
  text-align: left;
  background: #fcfcfc;
}

.homepage-hero .tab-content > .active > ul {
  margin: 0;
}

.subtle-bottom-shadow {
  z-index: 1;
  position: relative;
  -webkit-box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.25);
}

#external-events {
  width: 150px;
  padding: 0 10px;
  border: 1px solid #ccc;
  background: #eee;
  text-align: left;
  position: absolute;
}

#external-events h4 {
  font-size: 16px;
  margin-top: 0;
  padding-top: 1em;
}

.external-event {
  /* try to mimick the look of a real event */
  margin: 10px 0;
  padding: 2px 4px;
  color: #fff;
  font-size: 0.85em;
  cursor: pointer;
}

#external-events p {
  margin: 1.5em 0;
  font-size: 11px;
  color: #666;
}

#external-events p input {
  margin: 0;
  vertical-align: middle;
}

#external-calendar {
  padding-left: 175px;
}

.dashboard .panel-switches td {
  vertical-align: middle;
  padding: 12.5px;
}

.dashboard .panel-switches td .rubix-icon {
  width: 18px;
  position: relative;
  display: inline-block;
  margin-left: 12.5px;
}

.dashboard .panel-switches-text {
  margin-left: 12.5px;
}

.dashboard .panel-switches td.panel-switches-holder {
  text-align: right;
  padding-right: 25px;
}

/* CHECK */
@media (min-width: 990px) {
  .dashboard .map-tcontainer {
    margin-left: 25px;
  }
}

.dashboard .mapt tr:first-child > td {
  border-top: none;
}

.dashboard .mapt td {
  vertical-align: middle;
}

.dashboard .mapt td .rubix-icon {
  line-height: 0;
}

.dashboard .map-dest .rubix-icon {
  top: -2px;
  font-size: 20px;
  position: relative;
}

.li-dashboard {
  display: block;
  pointer-events: all;
  /* height: 45px; */
}

.li-dropdown {
  overflow: visible !important;
}

.li-more-icon {
  -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
          transform: rotate(90deg);
}

html.default body #sidebar {
  z-index: 3030000;
}

html.default body #sidebar #sidebar-container,
html.default body #sidebar #sidebar-container .sidebar {
  overflow-x: hidden;
  overflow-y: auto;
  -ms-scroll-chaining: none;
      overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.dropdown-width {
  width: 100% !important;
}

.default-color {
  background-color: #ffffff !important;
}

.user-name-center {
  padding-left: 12px;
  text-align: center;
}

.heading-inline {
  display: inline;
}

.name-list-info {
  padding: 0 !important;
  height: auto !important;
  color: #2862b7;
  font-size: 14px;
  text-align: left;
  border: 0;
  outline: none !important;
}

.user-pending-request-info {
  width: 100%;
  text-align: left;
  margin-bottom: 8px;
  line-height: 15px;
  text-transform: uppercase;
}

.patient-slot-list-info {
  padding: 0 !important;
  height: auto !important;
  color: #2862b7 !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
  width: 100%;
  border: 0;
  outline: none !important;
}

.approve-tag {
  padding: 0 !important;
  height: auto !important;
  color: #5cb85c;
}

.deny-tag {
  padding: 0 !important;
  height: auto !important;
  color: #d9534f;
  margin-left: 10px;
}

.school-info {
  width: 1px !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

.dropdown-menu {
  /* margin-left: 20px !important;
  margin-top: 0; */
}

.table-responsive {
  overflow-x: unset !important;
  min-height: 0.01%;
}

.choose-btn {
  padding-right: 0 !important;
  padding-top: 0 !important;
}

/* input[type="file"] {
  display: none;
} */

.circleBtn {
  margin-bottom: 5px;
  margin-left: 5px;
  padding-left: 6px;
  padding-right: 6px;
  border-radius: 20px;
}

.btn-back {
  color: #428bca !important;
  text-transform: none !important;
}

.back-icon {
  font-size: 16px !important;
  position: relative;
  top: 1px;
}

.date-picker-d {
  position: absolute;
  z-index: 1;
  right: 30px;
  top: 30px;
  /* border: 2px solid #79b0ec;
  border-radius: 20px; */
}

.calendar-disable-date {
  background-color: #fff;
  color: #000;
  border: 2px solid #79b0ec;
  border-radius: 10px;
}
/* .react-calendar__tile {
  font-weight: bold;
} */

/* 
.calendar-tile {
  font-weight: bold;
  background-color: brown;
}

.react-calendar__tile {
  font-weight: bold;
}

.react-calendar__tile--active {
  background: #006edc;
  color: white;
}

.react-calendar__tile--now {
  background: transparent;
  => font-weight: bold;
  color: black; 
}

.react-calendar__tile--active:enabled:hover {
  background-color: #f0f0f0;
  => font-weight: bold;
  color: black; 
}

.calendar-tile-highlight {
  background-color: red;
  margin-top: 100px;
} */

.react-calendar {
  width: 400px;
  max-width: 100%;
  background-color: #fff;
  color: #222;
  border-radius: 8px;
  -webkit-box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.125em;
  padding: 10px;
}
.react-calendar__navigation button {
  color: #079EDA;
  min-width: 44px;
  background: none;
  font-size: 16px;
  margin-top: 8px;
}
.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #f8f8fa;
}
.react-calendar__navigation button[disabled] {
  background-color: #f0f0f0;
}
abbr[title] {
  text-decoration: none;
}
.react-calendar__month-view__days__day--weekend {
  color: #222;
  /* text-decoration: line-through; */
}

.react-calendar__tile:disabled,
.react-calendar__tile:disabled {
  background: #f8f8fa;
  color: #222;
  border-radius: 6px;
  text-decoration: line-through;
}

.react-calendar__tile:disabled {
  background: #fff;
}

.react-calendar__tile:enabled {
  background: #f8f8fa;
  font-weight: bold;
  border: solid 0.5px #079EDA;
  border-radius: 6px;
}

.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  /* background: #f8f8fa; */
  /* color: #079EDA; */
  border-radius: 6px;
  font-weight: bold;
  background: #079EDA;
  color: white;
}
.react-calendar__tile--now {
  background: #6f48eb33;
  border-radius: 6px;
  /* font-weight: bold; */
  color: #079EDA;
}
.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  /* background: #6f48eb33; */
  border-radius: 6px;
  /* font-weight: bold; */
  color: #079EDA;
}
.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: #f8f8fa;
}
.react-calendar__tile--active {
  background: #079EDA;
  border-radius: 6px;
  /* font-weight: bold; */
  color: #222;
}
.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: #079EDA;
  color: white;
}
/* .react-calendar--selectRange .react-calendar__tile--hover {
  background-color: #f8f8fa;
 }
 .react-calendar__tile--range {
  background: #f8f8fa;
  color: #079EDA;
  border-radius: 0;
 }
 .react-calendar__tile--rangeStart {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background: #079EDA;
  color: white;
 }
 .react-calendar__tile--rangeEnd {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background: #079EDA;
  color: white;
 } */

.date-picker-modal {
  position: absolute;
  z-index: 1;
  /* right: 30px;
  top: 30px; */
  border: 2px solid #79b0ec;
  border-radius: 12px;
}

.header-logo {
  color: #fbfff9 !important;
  font-size: 22px;
}

.profile-img-circle {
  border-radius: 5%;
  width: 30px;
  height: 30px;
}

.main-img-circle {
  border-radius: 75%;
  width: 200px;
  height: 200px;
}

.profile-img-rectangle {
  width: 150px;
  height: 83px;
  position: absolute;
  top: 28px;
}

.list-img-circle {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  /*background-color: wheat;*/
}

.patient-list-img-circle {
  width: 16px;
  height: 16px;
  margin-top: -1px;
}

.eye-input {
  position: absolute;
  top: 7px;
  right: 30px;
  z-index: 10;
  cursor: pointer;
}

.full-page {
  height: 100%;
  min-height: 100%;
}

.chip {
  display: inline-block;
  padding: 0px 10px;
  height: 16px;
  font-size: 10px;
  line-height: 16px;
  border-radius: 25px;
  background-color: #aaaaaa;
  color: #ffffff;
}

h5 {
  font-size: 15px;
}

.patient-address-home {
  line-height: 15px;
  color: #333;
}

.rubix-panel-container.panel-collapse-bottom {
  overflow: visible;
}
.input-group-addon {
  background: none;
}
.has-error .input-group-addon {
  background: none;
}
.border-blue {
  background: #ffffff;
  border: 2px solid #079EDA;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border-radius: 20px !important;
  height: 63px !important;
}
.forget-pass {
  padding: 0px 25px !important;
  color: #022144;
  font-size: 16px;
  font-weight: 600;
  text-transform: capitalize;
}
.form-label {
  font-size: 18px;
  color: #022144;
  text-transform: capitalize;
}
.input1 {
  margin-bottom: 20px !important;
}
.full-button {
  width: 96%;
  padding: 14px !important;
  margin-top: 48px;
  border-radius: 10px;
}
.icon-right {
  float: right;
}
.bg-darkblue.btn {
  text-transform: capitalize !important;
}
.heading-main {
  /* margin: 40px 0px 40px;
  padding: 15px; */
  font-weight: bold;
  color: #022144;
  font-size: 36px !important;
}

.pdf-warning-container {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
      align-items: center;
  gap: 8px;
}
.pdf-review-warning-icon {
  height: 30px;
  width: 30px;
}
.pdf-review-warning-text {
  color: #f71919;
  font-size: 22px;
  margin-top: 5px;
  text-align: left;
}

.tiles-opt-heading {
  color: #000;
  font-size: 36px;
  margin-bottom: 30px;
  margin-top: 10px;
}
.splash-li {
  list-style: none;
  display: -ms-flexbox;
  display: flex;
  float: right;
}
.splash-li li {
  color: #89949b;
  padding-right: 20px;
}
.splash-li li a {
  color: #89949b !important;
}
.btn-padding {
  padding: 15px 45px !important;
  -webkit-box-shadow: 0px 4px 4px 0px #858585;
          box-shadow: 0px 4px 4px 0px #858585;
}
.font-weight-600 {
  font-weight: 600;
}
.disclamer {
  font-size: 16px;
}
html.default body .sidebar-nav > li.active > a svg {
  color: #797979;
}
.list-btn {
  border-radius: 10px !important;
}
.padding-l-r50 {
  padding-left: 25px;
  padding-right: 25px;
}
.font-size25 {
  font-size: 25px;
}

.logout a {
  padding: 18px !important;
}
.radio-btn {
  width: 100%;
  display: -ms-inline-flexbox;
  display: inline-flex;
  text-align: center;
  border: 2px solid #000;
  border-radius: 5px;
  padding: 5px 20px;
  font-size: 10px;
  line-height: 20px;
}
.radio-btn-div {
  -webkit-columns: 3;
     -moz-columns: 3;
          columns: 3;
  -ms-flex-direction: row;
      flex-direction: row;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  height: auto;
  text-align: center;
}
.radio-text {
  font-size: 15px;
  color: #000;
  text-align: center;
  width: 100%;
}
.text-field-radio {
  border: 2px solid #797979 !important;
  border-radius: 10px !important;
  padding: 5px 10px;
}
.text-field {
  border: 2px solid #797979 !important;
  border-radius: 10px !important;
  height: 35px;
  font-size: 20px;
}
.text-field:focus {
  border: 2px solid #428bca !important;
}
.text-field:disabled {
  background-color: #e9ecef !important;
  border-color: #b8c0c8 !important;
  color: #2d3748 !important;
  opacity: 1;
  -webkit-text-fill-color: #2d3748;
}
.text-field-textarea {
  width: 100% !important;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  display: block;
  min-height: 185px;
  height: auto;
  padding: 12px 14px;
  font-size: 16px;
  line-height: 1.4;
  resize: vertical;
}
.scar-int-field {
  border: 1px solid rgb(0, 145, 226) !important;
  border-radius: 20px !important;
  height: 35px;
  font-size: 16px;
  width: 100% !important;
}
.scar-add-more {
  cursor: pointer;
  /* color: rgb(0, 145, 226); */
}
.scar-add-more:hover {
  color: rgb(0, 145, 226);
}

.scar-delete {
  cursor: pointer;
  /* color: rgb(255,0,0) */
}
.scar-delete:hover {
  color: rgb(255, 0, 0);
}

.img-hover-shadow {
  border-radius: 20px;
  width: 210px;
  cursor: pointer;
}

.img-hover-shadow:hover {
  -webkit-box-shadow: 0px 4px 4px 0px #858585;
          box-shadow: 0px 4px 4px 0px #858585;
}

.p-0 {
  padding: 0px !important;
}
.border-radius25 {
  border-radius: 25px !important;
}
.big-btn {
  font-size: 26px;
  padding: 15px 25px !important;
}
.paddingLR-90 {
  padding-left: 90px;
  padding-right: 90px;
}
.select-box,
.select-box-abnormal {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  color: #fff;
  border-radius: 9px !important;
  height: 35px;
  font-size: 18px;
  line-height: 35px;
  padding: 0 40px 0 12px;
}
.select-box {
  background-color: #079EDA;
  border-color: #079EDA;
}
.select-box-abnormal {
  background-color: #f12f39;
  border-color: #f12f39;
}
.select-box:disabled,
.select-box-abnormal:disabled {
  background-color: #e9ecef;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%234a5568' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  border-color: #cbd5e0;
  color: #2d3748;
  opacity: 1;
  -webkit-text-fill-color: #2d3748;
}
.diagnosis-remarks-prefill {
  width: 90%;
  margin: 1.5rem auto 0 auto;
  text-align: left;
}

.diagnosis-remarks-prefill__label {
  display: block;
  color: #6f7f86;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 8px;
}

.diagnosis-remarks-prefill__added-diagnoses {
  margin-bottom: 10px;
  padding: 9px 12px;
  border: 1px solid #c9e7f2;
  border-radius: 4px;
  background: #f4fbfe;
  color: #25333a;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
}

.diagnosis-remarks-prefill__added-diagnoses strong {
  color: #079EDA;
  font-weight: 800;
}

.diagnosis-remarks-prefill__select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  min-height: 44px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border: 1px solid #b8d7e4;
  border-radius: 6px;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23079EDA' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-position: right 14px center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  color: #25333a;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.35;
  padding: 10px 44px 10px 14px;
  -webkit-box-shadow: 0 2px 8px rgba(7, 158, 218, 0.08);
          box-shadow: 0 2px 8px rgba(7, 158, 218, 0.08);
}

.diagnosis-remarks-prefill__select:focus {
  border-color: #079EDA;
  outline: none;
  -webkit-box-shadow: 0 0 0 3px rgba(7, 158, 218, 0.15);
          box-shadow: 0 0 0 3px rgba(7, 158, 218, 0.15);
}

.diagnosis-remarks-prefill__disclaimer {
  margin-top: 10px;
  padding: 10px 12px;
  border-left: 4px solid #ef1c1c;
  border-radius: 4px;
  background: #fff5f5;
  color: #b71c1c;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
}

.diagnosis-remarks-prefill__disclaimer strong {
  font-weight: 800;
}

.diagnosis-remarks-prefill .diagnosis-remarks-prefill__textarea {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  display: block;
  margin-top: 12px;
  width: 100%;
}

.textarea-dropdown-prefill {
  margin-bottom: 14px;
}

.radio-modal-textarea-sub {
  color: #6f7f86;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  margin: 12px 4px 2px 4px;
  text-align: left;
}

.radio-modal-dropdown-text {
  clear: both;
  display: grid;
  gap: 12px;
  margin: 0 0 24px;
  padding-top: 20px;
  text-align: left;
}

.radio-modal-dropdown-text__select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 100%;
  max-width: 100% !important;
  height: 48px;
  border: 1px solid #079EDA;
  border-radius: 6px;
  background-color: #f4fbfe;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23079EDA' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-position: right 14px center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  color: #25333a;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1.5;
  margin: 0;
  padding: 10px 44px 10px 14px;
  cursor: pointer;
}

.radio-modal-dropdown-text__select:hover {
  border-color: #0072b0;
  background-color: #eaf7fc;
}

.radio-modal-dropdown-text__select:focus,
.radio-modal-dropdown-text__other:focus {
  border-color: #079EDA;
  outline: 2px solid #079EDA;
  outline-offset: 2px;
}

.radio-modal-dropdown-text__other {
  display: block;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 100%;
  min-height: 96px;
  border: 1px solid #079EDA;
  border-radius: 6px;
  color: #25333a;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 1.5;
  margin: 0;
  padding: 10px 14px;
  resize: vertical;
}

@media (max-width: 768px) {
  .diagnosis-remarks-prefill {
    width: 94%;
  }

  .diagnosis-remarks-prefill__select {
    font-size: 15px;
  }
}
.custom-radio {
  width: 30px;
  height: 30px;
}
.custom-radio:checked:after {
  width: 30px;
  height: 30px;
  content: "";
  border-radius: 50%;
  background-color: #079EDA !important;
    border-color: #079EDA !important;
  display: inline-block;
}
.custom-radio:after {
  width: 30px;
  height: 30px;
  content: "";
  border-radius: 50%;
  border: 1px solid grey;
  background-color: white !important;
  display: inline-block;
}

.abnormal-radio {
  width: 30px;
  height: 30px;
}
.abnormal-radio:checked:after {
  width: 30px;
  height: 30px;
  content: "";
  border-radius: 50%;
  background-color: #f12f39 !important;
  border-color: #f12f39 !important;
  display: inline-block;
}
.abnormal-radio:after {
  width: 30px;
  height: 30px;
  content: "";
  border-radius: 50%;
  border: 1px solid grey;
  background-color: white !important;
  display: inline-block;
}

.muscle-strength-rate {
  text-align: center;
  color: #000;
}
.rules-pill {
  width: 80px;
  border: none;
  font-size: 16px;
  color: #fff;
  padding: 6px;
  text-align: center;
  text-decoration: none;
  margin: 4px 2px;
  border-radius: 15px;
  font-weight: bold;
}
.select-option {
  background: #fff;
  color: #52575c;
  font-size: 24px;
}
.yesno-btn {
  font-size: 26px;
  padding: 12px 45px !important;
  border-radius: 10px !important;
  border: 3px solid #fff;
  margin-top: 30px;
  /* background: none; */
  color: #022144;
  border: 1px solid #022144;
  text-transform: capitalize;
  background-color: #fff;
  -webkit-box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
          box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
}
.textarea-blue {
  width: 100%;
  border: 2px solid #079EDA;
  border-radius: 20px;
  color: #333;
  font-size: 28px;
}
.show-with-ease {
  opacity: 1;
  -webkit-animation: showWithEase 1s;
}
@-webkit-keyframes showWithEase {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  30% {
    opacity: 0.3;
  }
  40% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.5;
  }
  60% {
    opacity: 0.6;
  }
  70% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}
@keyframes showWithEase {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  30% {
    opacity: 0.3;
  }
  40% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.5;
  }
  60% {
    opacity: 0.6;
  }
  70% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}

.show-textarea-with-ease {
  opacity: 1;
  -webkit-animation: showTAWithEase 1s normal forwards;
}
@-webkit-keyframes showTAWithEase {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.5;
  }
  75% {
    opacity: 0.75;
  }
  100% {
    opacity: 1;
  }
}
@keyframes showTAWithEase {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.5;
  }
  75% {
    opacity: 0.75;
  }
  100% {
    opacity: 1;
  }
}

.vertical-middle td {
  vertical-align: middle !important;
}
.review-box {
  padding: 20px 20px 20px 40px;
  /* width: 100%; */
  margin: 20px auto 20px;
  text-align: left;
  /* border: 2px solid #079EDA; */
  /* border-radius: 5px; */
  /* border-radius: 20px; */
  /* box-shadow: 0px 4px 10px rgb(0 0 0 / 25%); */
  background-color: #fff;

  -webkit-box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);

          box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);
  border-radius: 8px;
  border-top: 5px solid #079EDA;
}
.review-heading {
  font-size: 25px;
  line-height: 25px;
  font-weight: bold;
  color: #079EDA;
  /* color: #022144; */
  /* margin-bottom: 20px; */
}
.review-sub-heading {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #89949b;
  margin-top: 5px;
}
.review-answer {
  font-size: 18px;
  /* line-height: 10px; */
  /* font-weight: bold; */
  color: rgb(2, 33, 68);
}
.review-selected-answer {
  font-size: 20px;
  /* line-height: 10px; */
  font-weight: bold;
  color: #13e4a0;
}
.padding-left-50 {
  padding-left: 50px;
}
.mb-20 {
  margin-bottom: 20px;
}
.top-heading {
  margin-left: 20px;
  margin-bottom: 30px;
}
.button-bottom {
  padding-right: 20px;
  /* margin-top: 30px; */
}
.raido-label {
  width: 90%;
  /* margin-top: 7px; */
  line-height: 20px;
  padding: 14px;
  font-size: 18px;
}
.radio-left-div {
  width: 30%;
  float: left;
  border: 2px solid black;
  margin: 0px 3% 3% 0px;
  border-radius: 10px;
}
.radio-label-box {
  margin-bottom: 0px;
  width: 100%;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.radio-left-input {
  width: 10%;
  margin: 10px !important;
}
.radio-right-box-heading {
  margin-bottom: 20px;
  border-bottom: 1px solid rgb(238, 240, 247);
}
.radio-right-box-subhead2 {
  font-size: 20px;
  font-weight: bold;
  padding: 0px 40px 10px 20px;
}
.radio-right-box-subhead1 {
  font-size: 18px;
  font-weight: bold;
  padding: 10px 20px 0px;
}
.radio-right-innerbox {
  padding: 10px;
  width: 90%;
  margin: 0px auto;
}
.radio-right-innerbox-body {
  padding: 20px;
}
.radio-right-innerbox-label {
  margin-bottom: 0px;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
      justify-content: space-between;
  -ms-flex-align: center;
      align-items: center;
}
.radio-right-innerbox-label-text {
  width: 90%;
  line-height: 20px;
  font-size: 18px;
}

.radio-right-input {
  width: 10%;
  margin: 10px;
}
.textfield-2col {
  padding: 20px;
}
.textfield-2col-textarea {
  padding: 22px 28px 28px;
}
.textfield-2col-textarea .row {
  margin-left: 0;
  margin-right: 0;
}
.textfield-2col-textarea .row.col-md-12 {
  width: 100%;
  padding-left: 0;
  padding-right: 0;
}
.textfield-2col-textarea .textfield-heading {
  display: block;
  margin-bottom: 8px;
  font-size: 22px;
  line-height: 1.2;
  letter-spacing: 0;
}
.textfield-2col-textarea .textfield-subheading {
  display: block;
  max-width: 620px;
  margin: 0 auto 14px;
  font-size: 15px;
  line-height: 1.35;
  letter-spacing: 0;
}
.textfield-mt40 {
  margin-top: 40px;
}
.textfield-mb40 {
  margin-bottom: 40px;
}
.textfield-heading {
  font-size: 25px;
  line-height: 20px;
  line-height: 1;
  font-weight: bold;
  color: rgb(2, 33, 68);
}
.textfield-subheading {
  font-size: 16px;
  font-weight: bold;
}
.textfield-label {
  font-size: 11px;
  line-height: 15px;
}
.controlled-select-note {
  width: 90%;
  margin: 0 auto 16px;
  padding: 10px 14px;
  border-left: 4px solid #079EDA;
  border-radius: 4px;
  background: #f4fbfe;
  color: #25333a;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
  text-align: left;
}
.textfield-image-container:has(img.textfield-image) {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: center;
      align-items: center;
}
.textfield-image {
  width: 100%;
  min-width: 120px;
  height: auto;
}
.text-area {
  width: 90%;
}
.selectbox-header {
  margin-bottom: 10px;
  border-bottom: 1px solid rgb(238, 240, 247);
}
.selectbox-heading {
  font-size: 24px;
  font-weight: bold;
  padding: 10px 20px 10px 45px;
}
.selectbox-subheading1 {
  font-size: 18px;
  font-weight: bold;
  padding: 10px 20px;
  text-align: left;
}
.selectbox-subheading2 {
  font-size: 18px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-left: -50px;
}
.rms-legend-heading {
  font-size: 22px;
  font-style: italic;
  font-weight: bold;
  color: #000;
  margin-top: 15px;
}
.legend-position {
  background: #fff;
  cursor: pointer;
  margin-bottom: 20px;
  /* margin-top: -20px; */
  font-size: 18px;
  color: #022144;
  font-weight: bold;
  border-radius: 8px;
  margin-left: -2%;
  -webkit-box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);
          box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);
}
.selectbox-body {
  padding: 0px 20px 20px;
}
.selectbox-bodyinner {
  /* padding: 0px 20px 20px; */
}
.selectbox-single {
  padding: 5px;
  text-align: left;
}
.selectbox-label {
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: normal;
}
.yes-btn {
  padding-right: 20px;
  width: 50%;
  float: left;
}
.no-btn {
  padding-left: 20px;
  width: 50%;
  float: right;
}
.yesno-btn-row {
  bottom: 0px;
  margin-bottom: 15px;
}
.page-top-heading {
  margin-left: 20px;
  margin-bottom: 30px;
}
.height400 {
  height: 400px;
}
.heading-main-sub {
  margin-top: 5px;
  /* margin-bottom: 40px; */
  font-style: italic;
  font-size: 24px;
}
.heading-card {
  background: white;
  -webkit-box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);
          box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 1px;
  min-height: 135px;
}
.yesno-btn-div {
  bottom: 0px;
  margin-bottom: 15px;
}
.btn-back {
  padding-right: 20px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.btn-next {
  padding-left: 20px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

.radio-button-style {
  width: 30%;
  border: 2px solid #797979;
  margin: 25px auto;
  border-radius: 10px;
  margin-bottom: "3%";
  background-color: #fff;
}
.back-btn {
  width: 171px;
  background: none;
  border: 1px solid #797979;
  color: #797979;
  border-radius: 10px;
  -webkit-box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
          box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  text-transform: capitalize;
  font-weight: 400;
}
.back-btn:hover {
  background: none;
  border: 1px solid #797979;
  color: #797979;
  border-radius: 10px;
  -webkit-box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
          box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  text-transform: capitalize;
  font-weight: 400;
}
.reject-btn {
  width: 171px;
  background: #f12f39;
  border: 1px solid #f12f39;
  color: #fff;
  border-radius: 10px;
  -webkit-box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
          box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  text-transform: capitalize;
}
.accept-btn-width {
  width: 205px !important;
}
.backiconspan {
  font-size: 30px;
  float: left;
  margin-right: 35px;
}

.nexticonspan {
  font-size: 30px;
  float: right;
  margin-left: 35px;
  /* transform: translate(10px, 0px); */
}
.arrow-animate {
  -webkit-animation: spin 1s normal forwards;
  /* -moz-animation: spin 2s infinite linear;
  -o-animation: spin 2s infinite linear;
  animation: spin 2s infinite linear; */
}
/* @-moz-keyframes spin {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(359deg);
  }
} */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: translate(0px, 0px);
  }
  100% {
    -webkit-transform: translate(10px, 0px);
  }
}
/*@-o-keyframes spin {
  0% {
    -o-transform: rotate(0deg);
  }
  100% {
    -o-transform: rotate(359deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
} */
.review-btn {
  width: 171px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-transform: capitalize;
}
.next-btn {
  text-align: left;
  width: 171px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-transform: capitalize;
}
.complete-exam-btn {
  text-align: left;
  width: auto;
  border-radius: 10px;
  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-transform: capitalize;
}
.next-btn:hover {
  border-radius: 10px;
  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-transform: capitalize;
  background: #079EDA;
  color: white;
  border-color: #079EDA;
  /* transform: translate(5px, 0px); */
}

/* .next-btn:hover {
  border-radius: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-transform: capitalize;
  background: #079EDA;
  color: white;
  border-color: #079EDA;
} */
.yesno-btn:hover {
  background: #079EDA !important;
    border: 1px solid #079EDA;
  color: #fff;
  /* padding: 10px 43px 10px 43px !important; */
}

.yesno-btn-active {
  background: #079EDA !important;
    border: 1px solid #079EDA;
  color: #fff !important;
  /* padding: 10px 43px 10px 43px !important; */
}
.m-l-20 {
  margin-left: 20px;
}
.m-r-20 {
  margin-right: 20px;
}
textarea:focus,
input:focus {
  outline: none;
}

textarea {
  padding: 20px;
}

.table-th-font-size {
  font-size: 18px;
}

canvas {
  width: 100%;
  height: 300px;
}

.rom-panel-close-btn {
  width: 50px;
  height: 50px;
  border: 0.5px solid #333;
  border-radius: 50%;
  background: #fff;
  outline: none;
  font-size: 18px;
  color: #333;
}
.rom-panel-close-btn:hover {
  background: #eee;
}
.rom-panel-active {
  border: 3px solid #13e4a0;
  border-radius: 25px;
}

.rom-panel-not-active {
  border: 3px solid #fff;
  border-radius: 25px;
}

.sun-radio-custom {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.sun-img-custom {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 30px;
}
.sun-radio-custom:checked + .sun-img-custom {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.sun-img-custom.checked {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.overlay-msg {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3031000;
  padding: 7% 25% 10% 25%;
  overflow-y: auto;
}
.overlay-box {
  /* height: 30%; */
  background: white;
  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  border: solid 2px #079EDA;
  padding: 5%;
  text-align: center;
}
.overlay-msg.overlay-msg--detailed,
.overlay-msg.overlay-msg--dropdown {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: start;
      align-items: flex-start;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 24px 16px;
}
.overlay-msg--detailed .overlay-box,
.overlay-msg--dropdown .overlay-box {
  width: 100%;
  max-width: 760px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  /* Center shorter dialogs without clipping taller dialogs when scrolling. */
  margin: auto;
  padding: 28px;
}
.overlay-msg--dropdown .radio-modal-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 0;
}
.overlay-msg--dropdown .radio-modal-actions > div {
  width: auto;
  min-width: 0;
  padding: 0;
}
.overlay-msg--dropdown .radio-modal-actions button {
  width: 100% !important;
  min-width: 0;
  min-height: 44px;
  margin: 0;
  padding: 10px 12px !important;
  letter-spacing: 0;
  line-height: 1.35;
  text-align: center;
}
.overlay-msg--dropdown .radio-modal-textarea-sub {
  clear: both;
  margin: 0 4px;
  padding-top: 12px;
}
.overlay-msg--detailed .overlay-box h1 {
  font-size: 24px;
  line-height: 1.3;
  margin: 0;
}
.overlay-msg--detailed .overlay-box h4 {
  font-size: 16px;
  font-weight: 400;
  text-align: left;
}
.overlay-msg--detailed .backnext-btn-div {
  display: -ms-flexbox;
  display: flex;
  gap: 12px;
  margin: 0;
  -ms-flex-align: stretch;
      align-items: stretch;
}
.overlay-msg--detailed .backnext-btn-div::before,
.overlay-msg--detailed .backnext-btn-div::after {
  display: none;
}
.overlay-msg--detailed .backnext-btn-div .col-xs-6 {
  display: -ms-flexbox;
  display: flex;
  -ms-flex: 1 1;
      flex: 1 1;
  min-width: 0;
  padding: 0;
}
.overlay-msg--detailed .backnext-btn-div button {
  -ms-flex: 1 1;
      flex: 1 1;
  width: 100%;
  min-width: 0;
  min-height: 44px;
  margin: 0;
  padding: 10px 12px !important;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 1.35;
  text-align: center;
}
@media (max-width: 480px) {
  .overlay-msg--detailed .overlay-box {
    padding: 20px;
  }
}
.overlay-legend-reflex {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3031000;
  /* padding: 10%; */
  padding: 8% 30% 10% 30%;
}

.overlay-settings-help {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3031000;
  padding-left: 10%;
  padding-top: 35%;
}
.setting-help {
  width: 300px;
  height: 190px;

  background: #ffffff;
  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}
.logout .caret {
  color: transparent;
}

.modal-relative {
  position: relative;
}

.close-btn {
  position: absolute;
  top: 2px;
  right: 15px;
  cursor: pointer;
  font-size: 36px;
  color: #333;
  line-height: 1;
  padding: 0;
  background-color: transparent;
  border: none;
  -webkit-transition: color 0.2s ease;
  transition: color 0.2s ease;
}

.close-btn:hover {
  color: grey;
}

.docs-list {
  padding: 20px;
  background-color: #f7f7f7;
  border-radius: 8px;
}

.docs-list h2 {
  font-weight: 550;
  margin-bottom: 15px;
  color: #333;
}

.docs-list ul {
  list-style-type: none;
  padding: 0;
}

.doc-item {
  margin-bottom: 8px;
}

.doc-link {
  display: block;
  padding: 10px 15px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 4px;
  text-decoration: none;
  color: #333;
  cursor: pointer;
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
}

.doc-link:hover {
  color: #079EDA;
  background-color: #eef;
}

.loader-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.loader-img {
  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 0.7;
  -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}

.dropdown-header-vbg {
  background-image: url("/imgs/app/dot.svg");
  background-repeat: no-repeat;
  background-color: transparent;
  background-position: center;
}

.rdr-Calendar {
  /* width: 350px !important; */
  font-weight: bold !important;
  border-radius: 10px !important;
}
.rdr-WeekDay {
  font-size: 14px !important;
  font-weight: bold;
}
.rdr-Day {
  font-size: 14px !important;
  font-weight: bold !important;
}

.vbg-card-shadow {
  -webkit-box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}

.radio-left-heading {
  font-size: 24px;
  font-weight: bold;
  padding: 10px 20px;
}
.radio-left-sub-heading {
  font-size: 20px;
  font-weight: bold;
  padding: 0px 0px 0px 20px;
}
.radio-right-heading {
  font-size: 23px;
  font-weight: bold;
  padding: 10px 20px;
}
.radio-right-sub-heading {
  font-size: 24px;
  font-weight: bold;
  padding: 10px 20px;
}
.select-question-padding-left {
  padding-left: 15px;
}
.gif-file-msg-heading {
  color: rgb(0, 145, 226);
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 70px;
  text-align: center;
}
.gif-file-msg-status {
  color: rgb(2, 33, 68);
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 84px;
  text-align: center;
}
.calendar-span-width {
  border: 2px solid rgb(121, 176, 236);
  overflow: hidden;
  /* width: 105%; */
  width: 285px;
}
.select-rule-circle {
  background: rgb(0, 145, 226);
  border-radius: 50%;
  width: 10px;
  height: 10px;
  display: inline-block;
  padding: 5px;
  margin-top: 11px;
}
.splash-welcome-signin {
  padding: 0px 25px;
  margin: 30% auto 25px;
}
.glyphicon-spin {
  -webkit-animation: spin1 1500ms infinite linear;
  animation: spin1 1500ms infinite linear;
}
@-webkit-keyframes spin1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
/* @keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
} */
.dashboard-dbq {
  -webkit-transition: -webkit-transform 0.5s ease;
  transition: -webkit-transform 0.5s ease;
  transition: transform 0.5s ease;
  transition: transform 0.5s ease, -webkit-transform 0.5s ease;
}

/* [3] Finally, transforming the image when container gets hovered */
.dashboard-dbq:hover {
  -webkit-transform: scale(1.3);
      -ms-transform: scale(1.3);
          transform: scale(1.3);
  z-index: 1000;
  cursor: pointer;
}
.disabality-name-tooltip {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
      flex-direction: column;
  -ms-flex-align: center;
      align-items: center;
  -ms-flex-pack: center;
      justify-content: center;
  position: relative;
}
.disabality-name-tooltip .disabality-name-tooltip-text {
  visibility: hidden;
  width: 120px;
  background-color: #24292e;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 10;
  bottom: 120%;
  text-transform: capitalize;
  margin: auto;
}
.disabality-name-tooltip .disabality-name-tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #24292e transparent transparent transparent;
}
.disabality-name-tooltip:hover .disabality-name-tooltip-text {
  visibility: visible;
}
.dashboard-dbq-icon-caption {
  vertical-align: top;
  display: inline-block;
  text-align: center;
  padding: 10px;
}
@media only screen and (max-width: 700px) and (min-width: 200px) {
  .padding-l-r50 {
    padding-left: 40px;
    padding-right: 40px;
  }
  .paddingLR-90 {
    padding-left: 30px;
    padding-right: 30px;
  }
  .heading-main {
    margin: 20px 0px 0px;
    padding: 8px;
    font-weight: bold;
    color: #022144;
    font-size: 25px !important;
  }
  .tiles-opt-heading {
    color: #000;
    font-size: 25px;
    margin-bottom: 25px;
    margin-top: 10px;
  }
  .height400 {
    height: auto;
  }
  input[type="number"],
  input[type="text"] {
    display: block;
    width: 70%;
    margin: 0 auto;
  }
  .big-btn {
    font-size: 16px;
    padding: 10px 20px !important;
  }
  .mp-0 {
    padding: 0px;
  }
  .textfield-heading {
    font-size: 22px;
    line-height: 20px;
    font-weight: bold;
    color: rgb(2, 33, 68);
  }
  .textfield-subheading {
    font-size: 14px;
    font-weight: bold;
  }
  .yesno-btn {
    font-size: 20px;
    padding: 10px 35px !important;
    border-radius: 10px !important;
    border: 3px solid #fff;

    margin-top: 30px;
    background-color: #fff;
    color: #022144;
    border: 1px solid #022144;
    text-transform: capitalize;
  }

  .selectbox-subheading1 {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 20px;
    text-align: left;
  }
  .selectbox-subheading2 {
    font-size: 16px;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: -30px;
  }
  .selectbox-label {
    /* font-size: 16px;
    color: rgb(0, 0, 0); */
    /* line-height: 35px; */
  }
  .splash-container {
    margin: 0;
  }
  .loginFrom {
    overflow: auto;
  }
  .radio-button-style {
    width: 100%;
    border: 2px solid black;
    margin: 10px auto;
    border-radius: 10px;
  }
  .page-top-heading {
    margin-left: 20px;
    margin-bottom: 30px;
    margin-top: 0px;
    z-index: 1000;
  }
}
.dashboard-dbq-img-width {
  width: 80px;
}
.dashboard-name-font-size {
  font-size: 26px;
  text-align: center;
}
.dashboard-time-font-size {
  font-size: 36px;
  text-align: left;
  margin-top: 22px;
}
.dashboard-ssn-dob {
  font-size: 16px;
  text-align: center;
  color: #89949b;
}
.correct-dbq-panel {
  background: #ffffff;
  border: 2px solid #f12f39;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.correct-note-div {
  background: #ffffff;
  border: 1px solid #079EDA;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border-radius: 5px;
  /* font-style: normal; */
  /* font-weight: bold; */
  font-size: 18px;
  line-height: 19px;
  color: #000000;
  text-align: left;
  padding: 2%;
  margin-top: 30px;
}
.tr-corrected-dbq {
  border-bottom: 1px solid #dadada;
  color: #022144;
  font-weight: bold;
  font-size: 18px;
}
.tr-corrected-dbq td,
th {
  height: 55px;
  color: #022144;
}

@media only screen and (max-width: 1130px) and (min-width: 701px) {
  .overlay-settings-help {
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3031000;
    padding-left: 15%;
    padding-top: 30%;
  }
  .legend-position {
    background: #fff;
    cursor: pointer;
    margin-bottom: 20px;
    /* margin-top: -20px; */
    font-size: 18px;
    color: #022144;
    font-weight: bold;
    border-radius: 8px;
    margin-left: -5%;
    -webkit-box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);
            box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);
  }
  .dashboard-dbq-img-width {
    width: 75px;
  }
  .dashboard-name-font-size {
    font-size: 24px;
    text-align: center;
  }
  .dashboard-time-font-size {
    font-size: 36px;
    text-align: left;
  }
  .dashboard-ssn-dob {
    font-size: 14px;
    text-align: center;
    color: #89949b;
  }
  .pad-l-r-0 {
    padding-left: 0;
    padding-right: 0;
  }
  .font-size-tab {
    font-size: 12px;
  }
  .border-blue {
    background: #ffffff;
    border: 2px solid #079EDA;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    border-radius: 20px !important;
    height: 50px !important;
    font-size: 15px !important;
  }
  .h2-size-tab {
    font-size: 26px !important;
  }
  .h2-size-tab-name {
    font-size: 21px !important;
  }

  .rom-panel-close-btn-mr {
    margin-right: 5px;
  }
  .textarea-blue {
    width: 100%;
    border: 2px solid #079EDA;
    border-radius: 20px;
    color: #333;
    font-size: 22px;
  }
  .rules-pill {
    width: 60px;
    border: none;
    font-size: 16px;
    color: #fff;
    padding: 6px;
    text-align: center;
    text-decoration: none;
    margin: 4px 2px;
    border-radius: 15px;
    font-weight: bold;
  }
  canvas {
    width: 100%;
    height: 250px;
  }
  .radio-right-innerbox {
    padding: 10px;
    width: 100%;
    margin: 0px auto;
  }
  .radio-right-innerbox-width-tab {
    width: 90%;
  }
  .radio-left-heading {
    font-size: 19px;
    font-weight: bold;
    padding: 10px 20px;
  }
  .radio-left-sub-heading {
    font-size: 16px;
    font-weight: bold;
    padding: 0px 0px 0px 20px;
  }
  .radio-right-box-subhead1 {
    font-size: 14px;
    font-weight: bold;
    padding: 10px 20px 0px;
  }
  .margin-left-apt-time {
    margin-left: -15px;
  }
  .radio-right-heading {
    font-size: 22px;
    font-weight: bold;
    padding: 10px 20px;
  }
  .radio-right-sub-heading {
    font-size: 18px;
    font-weight: bold;
    padding: 10px 20px;
  }
  .selectbox-single {
    padding: 2px;
    text-align: left;
  }
  .gif-file-msg-heading {
    color: rgb(0, 145, 226);
    font-style: normal;
    font-weight: bold;
    font-size: 50px;
    line-height: 65px;
    text-align: center;
  }
  .gif-file-msg-status {
    color: rgb(2, 33, 68);
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 25px;
    text-align: center;
  }
  .overlay-msg {
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 3031000;
    /* padding: 10%; */
    padding: 5% 12% 10% 20%;
    overflow-y: auto;
  }

  .calendar-span-width {
    border: 2px solid rgb(121, 176, 236);
    overflow: hidden;
    /* width: 118%; */
    width: 280px;
  }
  .select-rule-circle {
    background: rgb(0, 145, 226);
    border-radius: 50%;
    width: 10px;
    height: 10px;
    display: inline-block;
    padding: 5px;
    margin-top: 11px;
    margin-right: 20px;
  }
  .splash-welcome-signin {
    padding: 0px 25px;
    margin: 15% auto 25px;
  }
  .padding-l-r50 {
    padding-left: 40px;
    padding-right: 40px;
  }
  .paddingLR-90 {
    padding-left: 30px;
    padding-right: 30px;
  }
  .heading-main {
    margin: 0px;
    padding: 8px;
    font-weight: bold;
    color: #022144;
    font-size: 30px !important;
  }
  .tiles-opt-heading {
    color: #000;
    font-size: 30px;
    margin-bottom: 25px;
    margin-top: 10px;
  }
  .height400 {
    min-height: 400px;
  }
  .accept-btn-width {
    width: 171px !important;
  }
  input[type="number"],
  input[type="text"] {
    display: block;
    width: 70%;
    margin: 0 auto;
  }
  .big-btn {
    font-size: 16px;
    padding: 10px 20px !important;
  }
  .mp-0 {
    padding: 0px;
  }
  .radio-size-small-screen {
    width: 28px;
  }
  .textfield-heading {
    font-size: 21px;
    line-height: 20px;
    font-weight: bold;
    color: rgb(2, 33, 68);
  }
  .radio-right-innerbox-label-text {
    width: 90%;
    margin-top: 7px;
    line-height: 20px;
    font-size: 14px;
  }
  .textfield-label {
    font-size: 10px;
    line-height: 15px;
  }
  .textfield-subheading {
    font-size: 14px;
    font-weight: bold;
  }
  .yesno-btn {
    font-size: 20px;
    padding: 10px 35px !important;
    border-radius: 10px !important;
    border: 3px solid #fff;
    margin-top: 30px;
    background-color: #fff;
    color: #022144;
    border: 1px solid #022144;
    text-transform: capitalize;
  }

  .selectbox-subheading1 {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 20px;
    text-align: left;
  }
  .selectbox-subheading2 {
    font-size: 16px;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: -30px;
  }
  .selectbox-label {
    font-size: 16px;
    color: rgb(0, 0, 0);
    font-weight: normal;
  }
  .splash-container {
    margin: 0;
  }
  .loginFrom {
    overflow: auto;
  }
  .radio-button-style {
    width: 100%;
    border: 2px solid black;
    margin: 10px auto;
    border-radius: 10px;
  }
  .page-top-heading {
    margin-left: 20px;
    margin-bottom: 30px;
    margin-top: 0px;
    z-index: 1000;
  }

  select {
    max-width: 85% !important;
    margin: 0 auto;
  }
  .padding-left-20 {
    padding-left: 20px;
  }
  .review-answer {
    line-height: 25px;
  }
  .select-question-padding-left {
    padding-left: 43px;
  }
}

@media only screen and (max-width: 1420px) and (min-width: 1131px) {
  .overlay-settings-help {
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3031000;
    padding-left: 12%;
    padding-top: 30%;
  }
  .dashboard-dbq-img-width {
    width: 80px;
  }
  .dashboard-name-font-size {
    font-size: 24px;
    text-align: center;
  }
  .dashboard-time-font-size {
    font-size: 36px;
    text-align: left;
    margin-left: -2%;
  }
  .dashboard-ssn-dob {
    font-size: 16px;
    text-align: center;
    color: #89949b;
    margin-bottom: -5px;
  }
  .radio-left-heading {
    font-size: 22px;
    font-weight: bold;
    padding: 10px 20px;
  }
  .radio-left-sub-heading {
    font-size: 18px;
    font-weight: bold;
    padding: 0px 0px 0px 20px;
  }
  .radio-right-box-subhead1 {
    font-size: 14px;
    font-weight: bold;
    padding: 10px 20px 0px;
  }

  .radio-right-heading {
    font-size: 21px;
    font-weight: bold;
    padding: 10px 20px;
  }
  .radio-right-sub-heading {
    font-size: 22px;
    font-weight: bold;
    padding: 10px 20px;
  }
  .selectbox-single {
    padding: 2px;
    text-align: left;
  }
  .gif-file-msg-heading {
    color: rgb(0, 145, 226);
    font-style: normal;
    font-weight: bold;
    font-size: 50px;
    line-height: 65px;
    text-align: center;
  }
  .gif-file-msg-status {
    color: rgb(2, 33, 68);
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 25px;
    text-align: center;
  }
  .overlay-msg {
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 3031000;
    /* padding: 10%; */
    padding: 5% 25% 10% 25%;
    overflow-y: auto;
  }
  .calendar-span-width {
    border: 2px solid rgb(121, 176, 236);
    overflow: hidden;
    /* width: 118%; */
    width: 280px;
  }
  .select-rule-circle {
    background: rgb(0, 145, 226);
    border-radius: 50%;
    width: 10px;
    height: 10px;
    display: inline-block;
    padding: 5px;
    margin-top: 11px;
    margin-right: 20px;
  }
  .splash-welcome-signin {
    padding: 0px 25px;
    margin: 15% auto 25px;
  }
  .padding-l-r50 {
    /* padding-left: 40px; */
    padding-right: 40px;
  }
  .paddingLR-90 {
    padding-left: 30px;
    padding-right: 30px;
  }
  .heading-main {
    margin: 20px 0px 0px;
    padding: 8px;
    font-weight: bold;
    color: #022144;
    font-size: 30px !important;
  }
  .tiles-opt-heading {
    color: #000;
    font-size: 30px;
    margin-bottom: 25px;
    margin-top: 10px;
  }
  .height400 {
    height: auto;
  }
  .accept-btn-width {
    width: 171px !important;
  }
  input[type="number"],
  input[type="text"] {
    display: block;
    width: 70%;
    margin: 0 auto;
  }
  .big-btn {
    font-size: 16px;
    padding: 10px 20px !important;
  }
  .mp-0 {
    padding: 0px;
  }
  .radio-size-small-screen {
    width: 28px;
  }
  .textfield-heading {
    font-size: 21px;
    line-height: 20px;
    font-weight: bold;
    color: rgb(2, 33, 68);
  }
  .radio-right-innerbox-label-text {
    width: 90%;
    margin-top: 7px;
    line-height: 20px;
    font-size: 14px;
  }
  .textfield-label {
    font-size: 10px;
    line-height: 15px;
  }
  .textfield-subheading {
    font-size: 14px;
    font-weight: bold;
  }
  .yesno-btn {
    font-size: 20px;
    padding: 10px 35px !important;
    border-radius: 10px !important;
    border: 3px solid #fff;
    margin-top: 30px;
    background-color: #fff;
    color: #022144;
    border: 1px solid #022144;
    text-transform: capitalize;
  }

  .selectbox-subheading1 {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 20px;
    text-align: left;
  }
  .selectbox-subheading2 {
    font-size: 16px;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: -30px;
  }
  .selectbox-label {
    font-size: 16px;
    color: rgb(0, 0, 0);
    font-weight: normal;
  }
  .splash-container {
    margin: 0;
  }
  .loginFrom {
    overflow: auto;
  }
  .radio-button-style {
    width: 100%;
    border: 2px solid black;
    margin: 10px auto;
    border-radius: 10px;
  }
  .page-top-heading {
    margin-left: 20px;
    margin-bottom: 30px;
    margin-top: 0px;
    z-index: 1000;
  }

  select {
    max-width: 85% !important;
    margin: 0 auto;
  }
  .padding-left-20 {
    padding-left: 20px;
  }
  .review-answer {
    line-height: 25px;
  }
  .select-question-padding-left {
    padding-left: 43px;
  }
}

@media only screen and (max-width: 1500px) and (min-width: 701px) {
  /* .height400 {
    height: auto;
  } */
  input[type="number"],
  input[type="text"] {
    display: block;
    width: 70%;
    margin: 0 auto;
  }
  .page-top-heading {
    margin-left: 20px;
    margin-bottom: 30px;
    margin-top: 0px;
    z-index: 1000;
  }
}

/* .stepper-wrapper {
  font-family: Arial;
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 10px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 10px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed .step-counter {
  background-color: #13e4a0;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #13e4a0;
  width: 100%;
  top: 10px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
} */

/* .stepper-wrapper {
  font-family: Arial;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
  color: #000;
}

.stepper-item.completed .step-counter {
  background-color: #13e4a0;
  color: white;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #13e4a0;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
} */

.stepper-wrapper {
  font-family: Arial;
  /* margin-top: 50px; */
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
      justify-content: space-between;
  margin-bottom: 10px;
}
.stepper-wrapper-overflow {
  overflow-x: scroll;

  &::-webkit-scrollbar {
    height: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #DDD;
    border-radius: 8px;
  }
}
.stepper-item {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
      flex-direction: column;
  -ms-flex-align: center;
      align-items: center;
  -ms-flex: 1 1;
      flex: 1 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 15px;
  left: -50%;
  z-index: 0;
  /* z-index: 2; */
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 15px;
  left: 50%;
  /* z-index: 2; */
  z-index: 0;
}

.stepper-item .step-counter {
  position: relative;
  /* z-index: 5; */
  z-index: 2;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: center;
      align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
  color: #000;
}

.stepper-item.completed .step-counter {
  background-color: #13e4a0;
  color: white;
  font-weight: bold;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #13e4a0;
  width: 100%;
  top: 15px;
  left: 50%;
  /* z-index: 2; */
  z-index: 1;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
}

.popover__wrapper {
  position: relative;
  margin-top: 1.5rem;
  display: inline-block;
}
.popover__before {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  /* left: -100px;
  transform: translate(0, -10px);
  background-color: #fff;
  padding: 1.5rem;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  width: auto; */
}

.popover__after {
  z-index: 10;
  opacity: 1;
  position: absolute;
  left: -170px;
  -webkit-transform: translate(0, -10px);
      -ms-transform: translate(0, -10px);
          transform: translate(0, -10px);
  background-color: #fff;
  /* padding: 1.5rem; */
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  width: 150px;
}
.popover__menu {
  padding: 7px 15px 7px 15px;
  cursor: pointer;
}
.popover__menu:hover {
  background-color: #f5f5f5;
}

.text-field-modal {
  border: 1px solid #ccc !important;
  border-radius: 10px !important;
  height: 35px;
  font-size: 15px;
  width: 100% !important;
}
.text-field-modal:focus {
  border: 1px solid #428bca !important;
}

.signature-pad {
  margin-top: 30px;
  width: 636px;
  height: 286px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  border: solid 3px #079EDA;
  position: relative;
  overflow: hidden;
}

.signature-pad canvas {
  width: 630px;
  height: 280px;
}

.signature-overlay {
  background-color: rgba(255, 255, 255, 0.85);
  position: absolute;
  border-radius: 10px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.ripple {
  background-position: center;
  -webkit-transition: background 0.8s;
  transition: background 0.8s;
}
.ripple:hover {
  background: #47a7f5 radial-gradient(circle, transparent 1%, #47a7f5 1%)
    center/15000%;
}
.ripple:active {
  background-color: #6eb9f7;
  background-size: 100%;
  -webkit-transition: background 0s;
  transition: background 0s;
}

.myButton {
  border: none;
  border-radius: 2px;
  padding: 12px 18px;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
  color: white;
  background-color: #2196f3;
  -webkit-box-shadow: 0 0 4px #999;
          box-shadow: 0 0 4px #999;
  outline: none;
}

.exam-menu {
  height: 50%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  /* position: fixed; 
  z-index: 1; 
  top: 130px;
  left: 135px;
  background-color: #111; 
  overflow-x: hidden; 
  padding-top: 60px; */
  -webkit-transition: 0.5s;
  transition: 0.5s;
}
.exam-menu-open {
  height: 85%; /* 100% Full-height */
  width: 50%; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1; /* Stay on top */
  top: 112px;
  left: 178px;
  background-color: #fff; /* e8ebf2*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding: 20px; /* Place content 60px from the top */
  -webkit-transition: 0.5s;
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
  /* border: 2px solid #0081c2; */
  -webkit-box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
          box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  text-align: left;
}

.exam-menu-card {
  margin-top: 1px;
  border-radius: 4px;
  background: #fff;
  -webkit-box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
          box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  padding: 14px 80px 18px 36px;
  /* cursor: pointer; */
}

.exam-menu-card:hover {
  -webkit-transform: scale(1);
      -ms-transform: scale(1);
          transform: scale(1);
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);
}

.review__normal {
  font-size: 18px;
  color: #022144;
}

.review__bold {
  font-size: 18px;
  font-weight: bold;
  color: #022144;
}

label {
  font-weight: bold !important;
}

.notification-badges li {
  /* display: inline-block; */
  /* min-width: 50px;
  height: 50px; */
  /* border: solid 1px #ccc; */
  vertical-align: top;
  /* margin-right: 10px; */
  text-align: center;
  /* line-height: 50px; */
  /* padding: 5px; */
}
.notification-badges [data-badge] {
  position: relative;
}
.notification-badges [data-badge]:after {
  position: absolute;
  right: 25px;
  top: 2px;
  min-width: 25px;
  min-height: 25px;
  line-height: 14px;
  padding: 5px;
  color: #fff;
  background-color: #bf1f1f;
  font-size: 14px;
  border-radius: 20px;
  content: attr(data-badge);
  border: solid 1px #c93a3a;
}

.dashboard-three-dots {
  padding-left: 10px;
  padding-right: 10px;
  color: #89949b;
  cursor: pointer;
  border-radius: 50%;
}

.dashboard-three-dots:hover {
  background-color: #eee;
  color: #000;
}

.font-card {
  background: white;
  -webkit-box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);
          box-shadow: 3px 3px 10px rgb(0 0 0 / 20%);
  border-radius: 8px;
  padding: 0;
  padding: 1px;
}

.rotate {
  -webkit-animation: rotate 1.5s linear infinite;
          animation: rotate 1.5s linear infinite;
}
@-webkit-keyframes rotate {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes rotate {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

/* SPINNER JUST FOR DEMO */
.spinner {
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  -webkit-box-shadow: inset -2px 0 0 2px #079EDA;
          box-shadow: inset -2px 0 0 2px #079EDA;
}

.script-char-count-text {
  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 80%);
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  min-height: 38px;
  width: 100% !important;
}

input::-webkit-calendar-picker-indicator{
  display: none;
}

input[type="date"]::-webkit-input-placeholder{ 
  visibility: hidden !important;
}

.rule-text {
  color: #ff5555;
  display: block;
  font-size: 18px;
  font-size: 24px;
  margin-top: 7px;
  font-weight: 700;
}


.cards-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 15px;
}

@media (min-width: 1500px) {
  .cards-container {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 2000px) {
  .cards-container {
    grid-template-columns: repeat(5, 1fr);
  }
}

.card-container {
  background-color: #fafbfb;
  border-radius: 8px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 10px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #585858;
  margin-bottom: 15px;
}

.questions-container {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
      justify-content: space-between;
}

@media (max-width: 1080px) and (max-height: 657px) {
  .questions-container {
    -ms-flex-direction: column;
        flex-direction: column;
    gap: 8px;
    -ms-flex-pack: normal;
        justify-content: normal;
  }
}

.radio-selection {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
      align-items: center;
  gap: 5px;
}

.radio-input {
  width: 25px;
  height: 25px;
}

h6 {
  font-size: 14px;
  text-align: left;
}

.question-item {
  border-radius: 8px;
  border: 2px solid transparent;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  cursor: pointer;
  padding: 8px;
  margin-right: 5px;
  -webkit-transition: 200ms;
  transition: 200ms;
}

.selected-joints {
  background-color: #cbf7e9;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-transition: 200ms;
  transition: 200ms;
}

.error-container {
  display: block;
  -webkit-animation: shake 350ms ease-in-out;
          animation: shake 350ms ease-in-out; /* Updated duration to 1 second for faster shake */
}

.error-message {
  color: #ef1c1c;
  font-weight: 700;
  font-size: 18px;
  -webkit-animation: blinkAnimation 5ms linear 0s 2;
          animation: blinkAnimation 5ms linear 0s 2;
  text-align: center;
}

@-webkit-keyframes shake {
  0%, 100% {
    -webkit-transform: translateX(0);
            transform: translateX(0); /* Starting position and ending position */
  }
  20% {
    -webkit-transform: translateX(-5px);
            transform: translateX(-5px); /* Move left */
  }
  40% {
    -webkit-transform: translateX(5px);
            transform: translateX(5px); /* Move right */
  }
  60% {
    -webkit-transform: translateX(-5px);
            transform: translateX(-5px); /* Move left again */
  }
  80% {
    -webkit-transform: translateX(5px);
            transform: translateX(5px); /* Move right again */
  }
}

@keyframes shake {
  0%, 100% {
    -webkit-transform: translateX(0);
            transform: translateX(0); /* Starting position and ending position */
  }
  20% {
    -webkit-transform: translateX(-5px);
            transform: translateX(-5px); /* Move left */
  }
  40% {
    -webkit-transform: translateX(5px);
            transform: translateX(5px); /* Move right */
  }
  60% {
    -webkit-transform: translateX(-5px);
            transform: translateX(-5px); /* Move left again */
  }
  80% {
    -webkit-transform: translateX(5px);
            transform: translateX(5px); /* Move right again */
  }
}

.selectedOption {
  background-color: #cbf7e9;
}

.question-cards-container {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.question-card {
  -ms-flex-preferred-size: 50%;
      flex-basis: 50%;
}

.reset-text-transform {
  text-transform: none;
}

.backnext-btn-div {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
      justify-content: space-between;
  -ms-flex-align: end;
      align-items: end;
}

.slide-info-text {
  font-size: 16px;
}

.slide-info-text-bold {
  font-size: 16px;
  font-weight: 600;
}

.page-number {
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin-bottom: 0;
}

.section-info {
  float: left;
  width: 10%;
  min-height: 10px;
}

.section-name {
  font-size: 13px;
}

.question-name {
  font-size: 15px;
}

/* Last disclaimer style overrides  */
.rubix-panel-body > div:last-of-type .option-disclaimer {
  top: auto !important;
  bottom: -15px;
}

/* Fix for diagnoses and extremities popup width */
.diagnoses-extremities-popup {
  position: absolute;
  z-index: 100;
  background: whitesmoke;
  border: 1.5px solid black;
  border-radius: 10px;
  padding: 10px 5px 5px 5px;
  margin-left: 10px;
  text-align: left;
  bottom: 0;
  min-width: 250px;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  max-height: 350px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
